<template>
<div container--fluid>
    <v-layout>
        <ProfileModule></ProfileModule>
    </v-layout>
</div>
</template>

<script>
import ProfileModule from '@modules/profile/index.vue';

export default {
    name: 'profile',
    components: {
        ProfileModule,
    },
    data(){
        return {
            //
        }
    },
};
</script>

<style scoped>

</style>
